/* global __COMMIT_HASH__, __COMMIT_FULL_HASH__, __COMMIT_DATE__ */

import React from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import { useMount } from 'react-nb-hooks'
import { createNavigationConfig } from 'loankeeper-common/components'

import { DocumentTitle } from 'shared'
import KeyHandler from 'shared/KeyHandler'
import { getSystemInfo, loadSystemInfoIfNeeded } from '../store/system'

const commit = __COMMIT_HASH__
const commitFull = __COMMIT_FULL_HASH__
const commitDate = moment(__COMMIT_DATE__).format('DD.MM.YYYY HH:mm:ss')
const currentYear = moment().format('YYYY')
const buildDate = process.env.BUILD_DATE

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 100px;
  padding: 20px;
  border-radius: 5px;

  img.cover {
    margin-right: 5px;
    width: 600px;
  }

  .bold {
    font-weight: bold;
  }

  p {
    margin: 0;
  }

  .build-info {
    display: flex;
    flex-direction: column;
    text-align: center;
    width: 150px;

    > div {
      background: #fff;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
      padding: 3px 10px;
    }

    > div:not(:last-child) {
      margin-bottom: 5px;
    }
  }
`

const AppBuildDate = ({ date }) => {
  const buildDate = React.useMemo(() => moment(date).format('DD.MM.YYYY HH:mm:ss'), [date])

  return <p>{buildDate}</p>
}

const SystemInfo = () => {
  const dispatch = useDispatch()

  const systemInfo = useSelector(getSystemInfo)

  useMount(() => {
    dispatch(loadSystemInfoIfNeeded())
  })

  if (systemInfo.status !== 'loaded') {
    return null
  }

  const { version, date } = systemInfo.data

  return (
    <>
      <p>{`Ver ${version}`}</p>
      <AppBuildDate date={date} />
    </>
  )
}

const BuildInfo = () => (
  <div className="build-info">
    <div>
      <p className="bold">LoanKeeper</p>
      <SystemInfo />
    </div>
    <div>
      <p>
        <a
          href={`https://bitbucket.org/dolphin-georgia/loankeeper-web/commits/${commitFull}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {commit}
        </a>
      </p>
      <p>{commitDate}</p>
      <p>Build Date</p>
      <p>{buildDate}</p>
    </div>
    <div>
      <p>
        &copy;
        {`2003-${currentYear}`}
      </p>
      <p>All Rights Reserved</p>
    </div>
    <div>
      <p>info@loankeeper.ge</p>
      <p>
        <a href="http://loankeeper.ge/" target="_blank" rel="noopener noreferrer">
          www.loankeeper.ge
        </a>
      </p>
    </div>
  </div>
)

const About = ({ history }) => (
  <Wrapper>
    <DocumentTitle title="About" />
    <KeyHandler targetKey="27" onKey={() => history.push('/secure')} />
    <img className="cover" src="/static/img/about_logo.png" alt="about" />
    <BuildInfo />
  </Wrapper>
)

export const createAboutNavigationItem = createNavigationConfig((translateFn) => ({
  icon: 'info',
  text: translateFn('mnu_help_about'),
  identity: '/secure/about',
}))

export default About
